export const crowdData = [
  {
    id: "shop_1",
    name: "Central Ration Store",
    capacity: 40,
    slots: {
      "09:00": 12,
      "10:00": 18,
      "11:00": 30,
      "12:00": 38,
      "17:00": 25,
      "18:00": 35
    }
  },
  {
    id: "shop_2",
    name: "City Fair Price Shop",
    capacity: 30,
    slots: {
      "09:00": 8,
      "10:00": 15,
      "11:00": 22,
      "12:00": 28,
      "17:00": 20,
      "18:00": 27
    }
  },
  {
    id: "shop_3",
    name: "Community Supply Center",
    capacity: 50,
    slots: {
      "09:00": 10,
      "10:00": 20,
      "11:00": 35,
      "12:00": 45,
      "17:00": 30,
      "18:00": 48
    }
  }
];
